import { Box, Paper, TextareaAutosize } from "@mui/material";
import { useState } from "react";
import { useCastersContext } from "../../CastersContext";
import { useTableStyles } from "../../styles/useTableStyles";
import { useFormHandlers } from "../hooks/useFormHandlers";

interface Props {
	reloadProcess: Function;
	refreshData: Function;
}

export const CommentsComponent = ({ reloadProcess, refreshData }: Props) => {
	const tableClasses = useTableStyles();
	const { state } = useCastersContext();
	const process = state.processData;

	const [value, setValue] = useState<string>(process?.Comments || "");

	const { handleOnFocus, handleOnBlurTextValue } = useFormHandlers({
		reloadProcess,
		refreshData,
	});
	return (
		<Paper elevation={0}>
			<Box padding={2}>
				<TextareaAutosize
					className={tableClasses.outlinedTextarea}
					placeholder="Comments"
					minRows={4}
					style={{ width: "100%" }}
					value={value}
					onFocus={() => handleOnFocus("Comments")}
					onChange={(e) => setValue(e.target.value)}
					onBlur={() => handleOnBlurTextValue("Comments", value)}
				/>
			</Box>
		</Paper>
	);
};
